document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector('form[action="/cart/add"].product-form');
  if (!form) return;

  const variants = window.productVariantsTagPrices;

  const formEl = $('form[action="/cart/add"].product-form');
  formEl.on("change", function () {
    let id = $(
      ".product-form .js-options .product__checkbox-input:checked"
    ).data("variant");

    if (!id) {
      id = $(
        ".product__wrapper .product-form .no-js.hide.js-product-selector"
      ).val();
    }

    if (!id) return;

    const variant = variants.find((variant) => `${variant.id}` === `${id}`);
    if (!variant) return;

    const price = document.querySelector("[data-tag-price-discounted-price]");
    const compare = document.querySelector("[data-tag-price-original-price]");
    const stickyPrice = document.querySelector(".sticky-add-to-cart__price");
    const stickyComparePrice = document.querySelector(
      ".sticky-add-to-cart__compare-price"
    );

    const subOption = document.querySelector(
      ".product-form [data-option-subsave] input"
    );
    const onetimeOption = document.querySelector(
      ".product-form [data-option-onetime] input"
    );

    const isSub =
      (subOption && subOption.checked) ||
      (onetimeOption && !onetimeOption.checked);

    if (price) {
      if (isSub) {
        price.innerHTML = variant.sub_price;
      } else {
        price.innerHTML = variant.discounted_price;
      }
    }

    if (compare) {
      if (isSub) {
        compare.innerHTML = variant.original_price;
      } else {
        compare.innerHTML = variant.original_price;
      }
    }

    if (stickyPrice) {
      if (isSub) {
        stickyPrice.innerHTML = variant.sub_price;
      } else {
        stickyPrice.innerHTML = variant.discounted_price;
      }
    }

    if (stickyComparePrice) {
      if (isSub) {
        stickyComparePrice.innerHTML = variant.original_price;
      } else {
        stickyComparePrice.innerHTML = variant.original_price;
      }
    }
  });
});
